const collectionDescriptionFunction = function() {
  const collectionReadMoreBtn = document.querySelector('.main-collection__read-more-btn');

  if (!collectionReadMoreBtn) return;

  collectionReadMoreBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const longDescription = document.querySelector('.main-collection__long-description');
    if (!longDescription) return;
    const longDescriptionHeight = getComputedStyle(longDescription.querySelector('.main-collection__long-description-content')).height;
    
    collectionReadMoreBtn.classList.toggle('open');
    if (collectionReadMoreBtn.classList.contains('open')) {
      // 1- Updated btn Label
      collectionReadMoreBtn.innerHTML = "Read Less";
      // 2- Show long description
      longDescription.style.maxHeight = longDescriptionHeight;
    } else {
      // 1- Updated btn Label
      collectionReadMoreBtn.innerHTML = "Read More";
      // 2- Hide long description
      longDescription.style.maxHeight = 0;
    }
  })
}

document.addEventListener('DOMContentLoaded', collectionDescriptionFunction);


// Adjusct Answer Height on Resize
window.addEventListener('resize', function() {
  const collectionReadMoreBtn = document.querySelector('.main-collection__read-more-btn');
  if (!collectionReadMoreBtn) return;
  const longDescription = document.querySelector('.main-collection__long-description');
  if (!longDescription) return;
  const longDescriptionHeight = getComputedStyle(longDescription.querySelector('.main-collection__long-description-content')).height;

  if (collectionReadMoreBtn.classList.contains('open')) longDescription.style.maxHeight = longDescriptionHeight;
})